// Scroll-driven depth layers inside the Helix section.
import { TOTAL_OFFSET } from './helix.js';

export function createParallax() {
  const top = document.querySelector('[data-hl-top]');
  const bottom = document.querySelector('[data-hl-bottom]');
  const lede = document.querySelector('[data-lede]');
  let origin = null;

  function update(offset) {
    if (origin === null) origin = offset;
    const p = (offset - origin) / TOTAL_OFFSET;

    if (top) top.style.transform = `translate3d(${p * -3}vw, ${p * -2}vh, 0)`;
    if (bottom) bottom.style.transform = `translate3d(${p * 3}vw, ${p * 2}vh, 0)`;
    if (lede) lede.style.transform = `translate3d(0, ${p * 6}vh, 0)`;
  }

  return { update };
}
